import { validateDomain, validateEmail, validateSupportCode, validateUserdata } from '../api/validate'

export const state = {
  userdata: {
    email: '',
    support_code: '',
    user_id: null,
    salutation: '',
    firstname: '',
    lastname: '',
    street: '',
    zip_code: '',
    city: '',
    country_id: '',
    phone: '',
    gtc: true,
    domain: ''
  },
  isLoading: false,
  customerWithEmailExists: null
}

export const getters = {
  userdata: (state) => {
    return state.userdata
  },
  isLoading: (state) => {
    return state.isLoading
  },
  customerWithEmailExists: (state) => {
    return state.customerWithEmailExists
  }
}

export const mutations = {
  SET_IS_LOADING: (state, isLoading) => {
    state.isLoading = isLoading
  },
  SET_DOMAIN: (state, domain) => {
    state.userdata.domain = domain
  },
  SET_EMAIL: (state, email) => {
    state.userdata.email = email
  },
  SET_SUPPORT_CODE: (state, supportCode) => {
    state.userdata.support_code = supportCode
  },
  SET_USER_ID: (state, userId) => {
    state.userdata.user_id = userId
  },
  SET_CUSTOMER_WITH_EMAIL_EXISTS: (state, exists) => {
    state.customerWithEmailExists = exists
  },
  UPDATE_USERDATA: (state, userdata) => {
    Object.assign(state.userdata, userdata)
  }
}

export const actions = {
  async ValidateDomain ({ dispatch, commit, state }, domain) {
    commit('SET_IS_LOADING', true)
    commit('form/RESET_ERRORS', null, { root: true })

    await validateDomain(domain, state.userdata.user_id)
      .then(({ data }) => {
        commit('SET_DOMAIN', domain)
      })
      .catch(error => {
        commit('form/SET_ERRORS', error.response.data.errors, { root: true })
      })

    commit('SET_IS_LOADING', false)

    return true
  },
  async ValidateEmail ({ dispatch, commit, state }, email) {
    commit('SET_IS_LOADING', true)
    commit('form/RESET_ERRORS', null, { root: true })
    commit('SET_CUSTOMER_WITH_EMAIL_EXISTS', null)

    await validateEmail(email)
      .then(({ data }) => {
        commit('SET_EMAIL', email)
        commit('SET_CUSTOMER_WITH_EMAIL_EXISTS', data.count > 0)
      })
      .catch(error => {
        commit('form/SET_ERRORS', error.response.data.errors, { root: true })
      })

    commit('SET_IS_LOADING', false)

    return true
  },
  async ValidateSupportCode ({ dispatch, commit, state }, supportCode) {
    commit('SET_IS_LOADING', true)
    commit('form/RESET_ERRORS', null, { root: true })

    await validateSupportCode(state.userdata.email, supportCode)
      .then(({ data }) => {
        commit('SET_SUPPORT_CODE', supportCode)
        commit('SET_USER_ID', data.id)
        return true
      })
      .catch(error => {
        commit('form/SET_ERRORS', error.response.data.errors, { root: true })
        return false
      })
      .finally(() => {
        commit('SET_IS_LOADING', false)
      })
  },
  async ValidateUserdata ({ dispatch, commit, state }, userdata) {
    commit('SET_IS_LOADING', true)
    commit('form/RESET_ERRORS', null, { root: true })

    await validateUserdata(userdata)
      .then(({ data }) => {
        commit('UPDATE_USERDATA', userdata)
        return true
      })
      .catch(error => {
        commit('form/SET_ERRORS', error.response.data.errors, { root: true })
        return false
      })
      .finally(() => {
        commit('SET_IS_LOADING', false)
      })
  }
}
